
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blog_slug]",
      function () {
        return require("private-next-pages/blog/[blog_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[blog_slug]"])
      });
    }
  